import { DraftStatuses } from 'providers/DraftActivityPlanProvider';
import React from 'react';
import { ActivityPlanStatus } from 'types';
import { ProgressionTypes } from 'utils/activityPlan';
import { Header } from '../../layout/Header';
import { TimeBasedUserChip } from '../../TimeBasedUserChip';
import { ActivityPlanStatusChip } from '../ActivityPlanStatus';
import { CurrentProgression } from '../CurrentProgression';
import { DraftStatus } from '../DraftStatus';
import { ViewOnly } from '../ViewOnly';

export interface AcuteHeaderProps {
  name: string;
  viewOnly?: boolean;
  draftStatus?: { status: DraftStatuses; lastUpdatedAt: Date };
}

export const AcuteHeader = ({
  name,
  viewOnly,
  draftStatus
}: AcuteHeaderProps): JSX.Element => (
  <Header title={name}>
    {viewOnly ? <ViewOnly /> : null}
    {draftStatus ? (
      <DraftStatus
        lastUpdatedAt={draftStatus.lastUpdatedAt}
        status={draftStatus.status}
      />
    ) : null}
  </Header>
);

export interface AcuteUserHeaderProps {
  bodyRegion: string;
  viewOnly?: boolean;
  userId: string;
  isTimeBasedUser?: boolean;
  currentWeek: number | null;
  draftStatus?: { status: DraftStatuses; lastUpdatedAt: Date };
  activityPlanStatus: { status: ActivityPlanStatus };
}

export const AcuteUserHeader = ({
  currentWeek,
  userId,
  isTimeBasedUser,
  bodyRegion,
  viewOnly,
  activityPlanStatus,
  draftStatus
}: AcuteUserHeaderProps): JSX.Element => (
  <Header title={`User ID: ${userId}`} subTitle={`Acute ${bodyRegion}`}>
    {isTimeBasedUser ? <TimeBasedUserChip /> : null}
    <ActivityPlanStatusChip status={activityPlanStatus.status} />
    {currentWeek ? (
      <CurrentProgression
        progressionLabel={ProgressionTypes.acute}
        current={currentWeek}
        targetId={`${ProgressionTypes.acute}${currentWeek}`}
      />
    ) : null}
    {viewOnly ? <ViewOnly /> : null}

    {draftStatus ? (
      <DraftStatus
        lastUpdatedAt={draftStatus.lastUpdatedAt}
        status={draftStatus.status}
      />
    ) : null}
  </Header>
);
